import { useQuery } from "@tanstack/react-query";
import { sessionService } from "../services/session.service";
import { QUERY_KEYS } from "../config/queryKeys";

export const useSessions = () => {
  return useQuery({
    queryKey: [QUERY_KEYS.SESSIONS],
    queryFn: () => sessionService.getSessions(),
    refetchInterval: 1000 * 5,
  });
}; 